/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_DescInputs */

const en_coaching_desc = /** @type {(inputs: Coaching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A private session with a senior engineer from the Bystep team: review your PRD and roadmap, unblock your agent workflow, or plan the next phase together. Scheduled through Cal.com.`)
};

const id_coaching_desc = /** @type {(inputs: Coaching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi privat bersama engineer senior dari tim Bystep: review PRD dan roadmap, bereskan alur kerja agent yang macet, atau rencanakan fase berikutnya bersama. Dijadwalkan lewat Cal.com.`)
};

/**
* | output |
* | --- |
* | "A private session with a senior engineer from the Bystep team: review your PRD and roadmap, unblock your agent workflow, or plan the next phase together. Sch..." |
*
* @param {Coaching_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_desc = /** @type {((inputs?: Coaching_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_desc(inputs)
	return en_coaching_desc(inputs)
});